import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, Button, DialogActions, Box, Icon } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const PopupDialog = ({
    open,
    onClose,
    title,
    subtitle,
    details = [],
    width = '450px',
    primaryActionLabel = 'Done',
    onPrimaryAction,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    padding: 3,
                    width,
                    maxWidth: '90%',
                    textAlign: 'center',
                },
            }}
        >
            <DialogTitle sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                <CheckCircleOutlineIcon sx={{ fontSize: 40, color: '#4caf50' }} />
                <Typography variant="h6" fontWeight="bold">
                    {title}
                </Typography>
                {subtitle && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        {subtitle}
                    </Typography>
                )}
            </DialogTitle>

            {details.length > 0 && (
                <DialogContent dividers sx={{ mt: 1 }}>
                    <Box
                        sx={{
                            borderRadius: 2,
                            backgroundColor: '#f9f9f9',
                            padding: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                        }}
                    >
                        {details.map((detail, idx) => (
                            <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                {detail?.icon && <Icon component={detail.icon} sx={{ color: '#6c757d' }} />}
                                <Typography variant="body1">{detail.text}</Typography>
                            </Box>
                        ))}
                    </Box>
                </DialogContent>
            )}

            <DialogActions sx={{ justifyContent: 'center', mt: 2 }}>
                <Button onClick={onPrimaryAction} variant="contained" size="large">
                    {primaryActionLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PopupDialog;
